import { render, staticRenderFns } from "./SelectIndustry.vue?vue&type=template&id=200c0875"
import script from "./SelectIndustry.vue?vue&type=script&lang=ts"
export * from "./SelectIndustry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports